export default "__VITE_ASSET__Dl8jjU$S__"